import * as React from "react";
import { Outlet } from "react-router-dom";

import { Header, Footer } from "components";
import pageStyles from "./styles";
import { useContext } from "react";
import { Store } from "hooks/main_store";

const Layout = () => {
  const styles = pageStyles();
  const { state } = useContext(Store);
  const { withBg, noheader, noFooter, beforeToExit, noPadding } =
    state.layoutConfig;

  return (
    <>
      <Header beforeToExit={beforeToExit} hide={noheader} />
      <div
        className={[
          styles.children,
          withBg ? styles.withBg : "",
          noheader ? styles.withoutHeader : "",
          noFooter ? styles.withFooter : "",
          noPadding ? styles.withoutPadding : "",
        ].join(" ")}
      >
        <Outlet />
      </div>
      {noFooter ? <></> : <Footer />}
    </>
  );
};

export default Layout;
